<template>
  <div class="ch_wday">
      <a @click="searchChkDate('Y');" :class="{'act': $store.state.usRecordSettings.chkDate=='Y'}">어제</a>
      <a @click="searchChkDate('D');" :class="{'act': $store.state.usRecordSettings.chkDate=='D'}">오늘</a>
      <a @click="searchChkDate('T');" :class="{'act': $store.state.usRecordSettings.chkDate=='T'}">내일</a>
      <a @click="searchChkDate('P');" :class="{'act': $store.state.usRecordSettings.chkDate=='P'}">이번주</a>
      <a @click="searchChkDate('N');" :class="{'act': $store.state.usRecordSettings.chkDate=='N'}">다음주</a>
  </div>
</template>

<script>
export default {
  methods: {
    searchChkDate (chkDate) {
      this.$store.dispatch('saveUsChkDateSetting', chkDate)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/kiwoom/usRecord/mb/common/DateSearch.vue